<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <el-button type="primary" icon="el-icon-plus" class="float-right" @click="handleAdd">Add</el-button>

        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li class="active">
            <router-link :to="{ name: 'devices' }">Devices</router-link>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content device-content">
        <!-- Basic Tables-->
        <div class="box" v-loading="loading">
          <div class="box-body">
            <div class="search-wrapper panel-heading col-sm-12">
              <form class="device-search-form" @submit.prevent="searchData">
                <input
                  type="text"
                  v-model="search"
                  placeholder="Search by serial, name, ICC Id, customer..."
                  @keyup.enter="searchData"
                />
                <select v-model="activityFilter" @change="applyGlobalFilters">
                  <option value="ALL">All devices</option>
                  <option value="ACTIVE">Online devices</option>
                </select>
                <button type="submit">Search</button>
              </form>
            </div>
            <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName" @row-click="onRowClick">
              <template slot="empty">Loading...</template>

              <el-table-column :width="10">
                <template scope="scope">
                  <el-tooltip class="item" effect="dark" :content="
                    isDeviceOnline(scope.row.serial)
                      ? 'Online'
                      : 'Offline'
                  " placement="left">
                    <OnlineStatus :status="isDeviceOnline(scope.row.serial)" />
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column prop="serial" label="Serial" :min-width="15"></el-table-column>
              <el-table-column prop="name" label="Name" :min-width="30"></el-table-column>
              <el-table-column prop="iccId" label="ICC Id" :min-width="15"></el-table-column>
              <el-table-column prop="created" label="Created" :min-width="30"></el-table-column>
              <el-table-column label="Last Online" :min-width="30">
                <template scope="scope">
                  {{ formatLastActive(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column prop="customer.name" label="Customer" :min-width="40"></el-table-column>


              <el-table-column label="Action" width="auto">
                <template scope="scope">
                  <el-row class="device-actions-row">
                    <el-tooltip class="item" effect="dark" content="Make snapshot" placement="top-start">
                      <el-button type="default" icon="el-icon-picture" circle class="btn-rounded" @click.stop="
  currentDevice = scope.row;
snapshotVisible = true;
                      "></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Xml File" placement="top-start">
                      <el-button type="default" icon="el-icon-tickets" circle class="btn-rounded"
                        @click="getXml(scope.row)" @click.stop="
  xmlVisible = true;
currentDevice = scope.row;
currentRow = scope.row.serial;
                        "></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Historical lookup" placement="top-start">
                      <el-button type="info" icon="el-icon-date" circle class="btn-rounded" @click.stop="
  currentDevice = scope.row;
videoSearchVisible = true;
                      "></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Live stream" placement="top-start">
                      <el-button type="danger" icon="el-icon-caret-right" circle class="btn-rounded" @click.stop="
  currentDevice = scope.row;
liveStreamVisible = true;
                      "></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Edit" placement="top-start">
                      <el-button type="primary" icon="el-icon-edit" circle class="btn-rounded"
                        @click.stop="handleEdit(scope.row)"></el-button>
                    </el-tooltip>
                    <template>
                      <el-tooltip class="item" effect="dark" content="Restore" placement="top-start"
                        v-if="scope.row.disabled">
                        <el-button type="success" icon="el-icon-refresh" circle class="btn-rounded"
                          @click.stop="handleRestore(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="Delete" placement="top-start" v-else>
                        <el-button type="danger" icon="el-icon-delete" circle class="btn-rounded"
                          @click.stop="handleDelete(scope.row)"></el-button>
                      </el-tooltip>
                    </template>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="box-footer">
            <el-pagination background :page-size="pagination.pageSize" layout="prev, pager, next, sizes"
              :total="tableTotal" :page-sizes="pagination.rowsPerPageItems"
              :current-page="pagination.pageNum" @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </section>
      <!-- /.content -->
      <VideoSearchDialog :device="currentDevice" :visible.sync="videoSearchVisible" />
      <LiveStreamDialog :device="currentDevice" :visible.sync="liveStreamVisible" />
      <SnapshotDialog :device="currentDevice" :visible.sync="snapshotVisible" />
      <XmlDialog :visible.sync="xmlVisible" :device="currentDevice" :serial="currentRow" :xmlData="xmlData"
        :isSuccessful="isSuccessful" :isLoading="isLoading" :hasError="hasError" />
    </div>
  </transition>
</template>
<style>
.el-table .disabled-row {
  background: oldlace;
}

.el-date-editor .el-range-separator {
  padding: 0;
}

.device-row {
  cursor: pointer;
}

.search-wrapper {
  margin-bottom: 14px;
}

.device-search-form {
  display: flex;
  align-items: center;
  gap: 10px;
}

.device-search-form input {
  width: 360px;
  max-width: 100%;
  height: 40px;
  border: 1px solid #b8bdc7;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 15px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.device-search-form input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
  outline: none;
}

.device-search-form button {
  height: 40px;
  min-width: 110px;
  padding: 0 16px;
  border: 1px solid #8e95a3;
  border-radius: 6px;
  background: #f7f8fb;
  color: #5f6572;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.device-search-form button:hover {
  border-color: #6b7280;
  background: #eef1f6;
  color: #3e4450;
}

.device-search-form select {
  height: 40px;
  min-width: 140px;
  border: 1px solid #b8bdc7;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 14px;
  background: #fff;
  color: #3e4450;
}

.device-search-form select:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
  outline: none;
}

@media (max-width: 768px) {
  .device-actions-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 5px;
  }

  .device-actions-row .item {
    display: flex;
    justify-content: center;
    margin: 0;
    width: 100%;
  }
}

</style>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import VideoSearchDialog from "./VideoSearchDialog";
import LiveStreamDialog from "./LiveStreamDialog";
import SnapshotDialog from "./SnapshotDialog";
import XmlDialog from "./XmlDialog";
import OnlineStatus from "../../common/OnlineStatus";
import { devicesClient } from "@api/devices";
import axios from "axios";
import { URL, getUrl } from "@api/constants";


export default {
  name: "devices",
  components: {
    OnlineStatus,
    VideoSearchDialog,
    LiveStreamDialog,
    SnapshotDialog,
    XmlDialog,
  },
  data() {
    return {
      currentDevice: null,
      currentRow: null,
      videoSearchVisible: false,
      liveStreamVisible: false,
      snapshotVisible: false,
      loading: false,
      xmlVisible: false,
      xmlData: "",
      isLoading: false,
      isSuccessful: false,
      hasError: false,
      isSearched: false,
      activityFilter: "ALL",
      clientMode: true,
      allDevices: [],
      filteredDataset: [],

    };
  },
  computed: {

    ...mapGetters("devices", ["list", "activeDevices", "search"]),

    tableData() {
      const sorted = this.sortOnlineFirst(this.filteredDataset);
      const from = (this.pagination.pageNum - 1) * this.pagination.pageSize;
      const to = from + this.pagination.pageSize;
      return sorted.slice(from, to);
    },

    tableTotal() {
      return this.filteredDataset.length;
    },

    search: {
      get: function () {
        return this.$store.getters["devices/search"];
      },
      set: function (value) {
        this.$store.commit("devices/setSearch", value);
      },
    },
    pagination: {
      get: function () {
        return this.$store.getters["devices/pagination"];
      },
      set: function (value) {
        this.$store.commit("devices/setPagination", value);
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.clientMode) return;
        this.loadDevices();
      }

    },
    deep: true,

  },
  methods: {
    ...mapMutations("devices", ["setActiveDevices"]),
    ...mapActions("devices", [
      "fetchDevices",
      "fetchActiveDevices",
      "deleteDevice",
      "restoreDevice",
      "searchDevices",
      "xmlSend",

    ]),
     
    getXml(row) {
      this.xmlData = "";
      this.isLoading = true;
      this.isSuccessful = false;
      const token = localStorage.getItem("jwt_access_token");
      const deviceSerial = { "deviceSerial": `${row.serial}` }
      axios.post(getUrl(URL.GET_XML_FILE), deviceSerial, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(res => {
        this.isLoading = false;
        this.xmlData = res.data.configuration;
      }).catch(err => console.log(err))
    },
    tableRowClassName({ row }) {
      return (row.disabled ? "disabled-row" : "") + " " + "device-row";
    },
    isDeviceOnline(serial) {
      const key = String(serial);
      return this.activeDevices.some((activeSerial) => String(activeSerial) === key);
    },
    sortOnlineFirst(devices) {
      const list = Array.isArray(devices) ? [...devices] : [];

      return list.sort((a, b) => {
        const aOnline = this.isDeviceOnline(a.serial) ? 1 : 0;
        const bOnline = this.isDeviceOnline(b.serial) ? 1 : 0;

        if (aOnline !== bOnline) {
          return bOnline - aOnline;
        }

        const aName = String(a.name || a.serial || '').toLowerCase();
        const bName = String(b.name || b.serial || '').toLowerCase();
        return aName.localeCompare(bName);
      });
    },
    rowMatchesQuery(row, query) {
      if (!query) return true;

      const customerName = row.customer && row.customer.name ? row.customer.name : "";
      const fields = [
        row.serial,
        row.name,
        row.deviceName,
        row.iccId,
        row.created,
        customerName,
      ];

      return fields.some((value) => String(value || "").toLowerCase().includes(query));
    },
    async fetchAllDevices() {
      const pageSize = 200;
      const firstResp = await devicesClient.getDevices(1, pageSize);
      const firstDevices = (firstResp.data && firstResp.data.devices) || [];
      const totalCount = (firstResp.data && firstResp.data.totalCount) || firstDevices.length;
      const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

      const requests = [];
      for (let page = 2; page <= totalPages; page += 1) {
        requests.push(devicesClient.getDevices(page, pageSize));
      }

      const responses = await Promise.all(requests);
      const otherDevices = responses.flatMap((resp) => (resp.data && resp.data.devices) || []);
      return [...firstDevices, ...otherDevices];
    },
    async refreshActiveDevicesFor(serials) {
      if (!Array.isArray(serials) || serials.length === 0) {
        this.setActiveDevices([]);
        return;
      }

      const resp = await devicesClient.getStatuses(serials);
      const statusMap = (resp && resp.data) || {};
      const activeDevices = Object.keys(statusMap).filter((serial) => statusMap[serial] === "ONLINE");
      this.setActiveDevices(activeDevices);
    },
    rebuildFilteredDataset() {
      const query = (this.search || "").trim().toLowerCase();
      const filterActiveOnly = this.activityFilter === "ACTIVE";

      this.filteredDataset = this.allDevices.filter((row) => {
        if (filterActiveOnly && !this.isDeviceOnline(row.serial)) {
          return false;
        }

        return this.rowMatchesQuery(row, query);
      });
    },
    async applyGlobalFilters() {
      this.loading = true;

      if (this.pagination.pageNum !== 1) {
        this.pagination = { ...this.pagination, pageNum: 1 };
      }

      try {
        if (!this.allDevices.length) {
          this.allDevices = await this.fetchAllDevices();
          await this.refreshActiveDevicesFor(this.allDevices.map((d) => d.serial));
        }

        this.rebuildFilteredDataset();
      } finally {
        this.loading = false;
      }
    },
    async loadDevices() {
      this.loading = true;
      try {
        this.allDevices = await this.fetchAllDevices();
        await this.refreshActiveDevicesFor(this.allDevices.map((d) => d.serial));
        this.rebuildFilteredDataset();
        this.isSearched = false;
      } finally {
        this.loading = false;
      }
    },
    formatLastActive(row) {
      if (this.isDeviceOnline(row.serial)) {
        return "Online";
      }

      const candidates = [
        row.lastActiveOn,
        row.lastActive,
        row.lastSeen,
        row.lastOnline,
        row.lastHeartbeat,
        row.updated,
        row.updatedAt,
        row.modified,
        row.modifiedAt,
      ];

      const value = candidates.find(v => v !== undefined && v !== null && v !== "");
      if (!value) {
        return "N/A";
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
        date.getHours()
      )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    handleEdit(row) {
      this.$router.push({ name: "editDevice", params: { serial: row.serial } });
    },
    onRowClick({ serial }) {
      this.$router.push({ name: "viewDevice", params: { serial } });
    },
    handleDelete(row) {
      this.$confirm("This will delete device. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.deleteDevice({ serial: row.serial }).then((_) =>
            this.$message({
              type: "success",
              message: "Delete completed",
            })
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    handleRestore(row) {
      this.restoreDevice({ serial: row.serial })
        .then((_) =>
          this.$message({
            type: "success",
            message: "Restoring completed",
          })
        )
        .then((_) => {
          this.loading = true;
          this.fetchDevices()
            .then(() => this.fetchActiveDevices())
            .then((_) => (this.loading = false))
            .catch((_) => (this.loading = false));
        });
    },

    handleAdd() {
      this.$router.push({ name: "addDevice" });
    },
    handleSizeChange(pageSize) {
      this.pagination = { ...this.pagination, pageSize };
    },
    handleCurrentChange(pageNum) {
      this.pagination = { ...this.pagination, pageNum };

    },
    searchData() {
      this.isSearched = true;
      this.applyGlobalFilters();
    }
  },

  created() {

    this.loadDevices();
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?344faa1b